import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

type Props = {
  housingId?: string;
};
export const useFetchCheckIfOffersExists = ({housingId}: Props) => {
  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.deals, housingId],
    queryFn: () =>
      API.upselling.fetchCheckIfOffersExists(`housing_id=${housingId}&is_active=true`),
    enabled: Boolean(housingId),
    refetchOnWindowFocus: false,
  });
};
